import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=62972670&scoped=true"
import script from "./CardModal.vue?vue&type=script&lang=js"
export * from "./CardModal.vue?vue&type=script&lang=js"
import style0 from "./CardModal.vue?vue&type=style&index=0&id=62972670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62972670",
  null
  
)

export default component.exports